import React from 'react';
import Box from 'components/Box';
import ErrorBoundary from 'components/ErrorBoundary';


const Page = (props) => {

	return (
		<ErrorBoundary>
			<Box direction="column" gutter={12}>
				{props.children}
			</Box>
		</ErrorBoundary>
	);
};

Page.propTypes = {
	...Box.propTypes
};

export const withPage = (Component) => props =>
	(
		<Page>
			<Component {...props} />
		</Page>
	);

export default Page;